import { createApiConsts } from '../../../Helpers/constants'

export const FILE_FORMATS = {
  AUDIO: [
    {
      i18nKey: 'wav',
      value: 'WAV',
    },
    {
      i18nKey: 'opus',
      value: 'OPUS',
    },
  ],
  VIDEO: [
    {
      i18nKey: 'webm',
      value: 'WEBM',
    },
    {
      i18nKey: 'webMVideoVP8',
      value: 'WEBM_VP8',
    },
    {
      i18nKey: 'webMVideoVP9',
      value: 'WEBM_VP9',
    },
  ],
} as const

export const CONTACT_EXPORT = createApiConsts('CONTACT_EXPORT')
